module.exports = __webpack_public_path__ + "img/logo2.cd3ad2e9.png";